import { useQuery } from "@tanstack/react-query";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import { useRemindersRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import {
	getNotificationCenterResolvingNowV2,
	type TimelineResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";
import { filterReminderItemsByRight } from "web_myplann/NotificationCenter/Utils/filterReminderItemsByRight";

const STALE_TIME_MS = 60_000;

interface ResolvingNowParams {
	limit?: number;
}

export const useResolvingNowQuery = (params?: ResolvingNowParams) => {
	const hasRemindersRight = useRemindersRightOptional();

	return useQuery({
		queryKey: NotificationCenterKeys.resolvingNow(params?.limit),
		queryFn: processResponseQuery(() =>
			getNotificationCenterResolvingNowV2(params?.limit),
		),
		staleTime: STALE_TIME_MS,
		select: (data: TimelineResponseDTO) =>
			filterReminderItemsByRight(data, hasRemindersRight),
	});
};
